import { Auth0SsoAuthService, Auth0SsoTokenResponse } from 'common/api';

export async function auth0SsoLoginApi(params: {
  authorizationCode: string;
}): Promise<Auth0SsoTokenResponse> {
  return Auth0SsoAuthService.auth0SsoAuthControllerExchangeCodeForToken(params);
}
